export default __webpack_public_path__ + "static/media/close.96c98a42.svg";